import { render, staticRenderFns } from "./client-profile-active-toggle-modal.vue?vue&type=template&id=4582cd12"
import script from "./client-profile-active-toggle-modal.vue?vue&type=script&lang=js"
export * from "./client-profile-active-toggle-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports